import { render, staticRenderFns } from "./Shopify.vue?vue&type=template&id=fab7db2a"
import script from "./Shopify.vue?vue&type=script&lang=js"
export * from "./Shopify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports